import script from "./competitionMess.vue?vue&type=script&setup=true&lang=js"
export * from "./competitionMess.vue?vue&type=script&setup=true&lang=js"

import "./competitionMess.vue?vue&type=style&index=0&id=cc179272&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc179272"]])

export default __exports__